// ABOUTME: Notification component for invoice payment reminders.
// ABOUTME: Displays with a receipt icon in orange to indicate pending payment.

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useTranslation } from "react-i18next";
import Text from "../../../theme/text/Text";

const InvoiceReminderNotificationsComp = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    return(
        <Box
            onClick={props.onClick ?? null}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                py:1.5,
                transition:"200ms",
                borderRadius:4,
                "&:hover" : {
                    background:colors.grey[100],
                    transition:"200ms",
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.orange[100] : colors.orange[100],
                    color:theme.palette.mode === "dark" ? colors.orange[400] : colors.orange[400],
                    borderRadius:3,
                }}
            >
                <ReceiptLongIcon fontSize="small"/>
            </Box>
            <Box flex={1}>
                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        mb:0.5,
                    }}
                >
                    <Text semibold>{t(props.type)}</Text>
                </Box>
                <Box>
                    <Text>{props.body}</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default InvoiceReminderNotificationsComp;
